import { SubmitHandler } from "react-hook-form";
import { FormEventSchema } from "./FormEventNew";
import { useCallback } from "react";
import { formatDayJSToDateString } from "../../../utils/dates";
import { Event, FormEventPostValues } from "../../../types/events";
import { useNavigate } from "react-router-dom";
import {
  useEventCreateMutation,
  useEventUpdateMutation,
  useEventUploadAttachmentsMutation,
} from "../../../features/api/apiSlice";
import { notification } from "antd";
import { getErrorMessage } from "../../../utils/errors/errors";

export default function useSubmit(isEditMode?: boolean, event?: Event) {
  const navigate = useNavigate();

  const [createEvent, { isLoading: isCreating }] = useEventCreateMutation();
  const [updateEvent, { isLoading: isUpdating }] = useEventUpdateMutation();
  const [postAttachments, { isLoading: isPostingAttachments }] =
    useEventUploadAttachmentsMutation();

  const create: SubmitHandler<FormEventSchema> = useCallback(
    async (values) => {
      try {
        const formattedDate = formatDayJSToDateString(values.dateEvt);
        const formattedValues: FormEventPostValues = {
          ...values,
          dateEvt: formattedDate,
          attachedFiles: undefined, // Files are uploaded spearatlly (see below)
        };
        console.log("Formatted Values", formattedValues);

        // 1) Create event
        const createdEvent = await createEvent(formattedValues).unwrap();
        console.log("Response createdEvent", createdEvent);

        // Show success notification
        notification.success({
          message: "EvÃ©nement crÃ©Ã©",
          description: `L'Ã©vÃ©nement ${values.name} a Ã©tÃ© crÃ©Ã© avec succÃ¨s.`,
        });

        // 2) Upload attachments (needs the created event id)
        const files: undefined | File[] = values?.attachedFiles;

        if (files?.length) {
          const responseUpload = await postAttachments({
            eventId: createdEvent.id,
            files,
          }).unwrap();
          console.log("Response Upload", responseUpload);
          // Show success notification
          notification.success({
            message: "PiÃ¨ces jointes ajoutÃ©es",
          });
        }

        console.log(`events/${createdEvent.id}`);

        // Navigate to event page
        navigate(`/events/${createdEvent.id}`);
      } catch (error) {
        console.error("Error creating event", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [createEvent, navigate, postAttachments],
  );

  const update: SubmitHandler<FormEventSchema> = useCallback(
    async (values) => {
      try {
        if (!event?.id) {
          throw new Error("Pas d'ID d'Ã©vÃ©nement");
        }

        const formattedDate = formatDayJSToDateString(values.dateEvt);
        const formattedValues: FormEventPostValues = {
          ...values,
          dateEvt: formattedDate,
          attachedFiles: undefined, // Files are uploaded separatly (see below)
        };
        console.log("Formatted Values", formattedValues);

        // 1) Update event
        const updatedEvent = await updateEvent({
          eventId: event.id,
          values: formattedValues,
        }).unwrap();
        console.log("Response update event", updatedEvent);

        // 2) Show success notification
        notification.success({
          message: "EvÃ©nement modifiÃ©",
          description: `L'Ã©vÃ©nement ${values.name} a Ã©tÃ© modifiÃ© avec succÃ¨s.`,
        });

        // 3) Upload attachments (if any new files selected)
        const files: undefined | File[] = values?.attachedFiles;

        if (files?.length) {
          await postAttachments({
            eventId: event.id,
            files,
          }).unwrap();
          notification.success({
            message: "PiÃ¨ces jointes ajoutÃ©es",
          });
        }

        // 4) Navigate to event page
        navigate(`/events/${event.id}`);
      } catch (error) {
        console.error("Error update event", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [updateEvent, event?.id, navigate, postAttachments],
  );

  return {
    onSubmit: isEditMode ? update : create,
    isLoading: isCreating || isPostingAttachments || isUpdating,
  };
}
